module.exports = ".row{margin-bottom:.5em}\n"